import React, { useEffect } from "react";
import SuccessAnimation from "../../assets/icons/update_img_icons/success.json";
import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";
import { useLocation, useNavigate } from "react-router-dom";

function OrderPlaceScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCrmFlow = Boolean(location.state?.crmSource);
  const crmFlowName = location.state?.crmFlowName || "";
  const isOrderFlow = isCrmFlow && crmFlowName === "Create Order";

  useEffect(() => {
    sessionStorage.removeItem("CartData");

    setTimeout(() => {
      navigate(location?.state?.backPath || `/`);
    }, 3000);
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <Box sx={{ height: "15vw", width: "15vw" }}>
        <Lottie animationData={SuccessAnimation} />
      </Box>
      <div style={{ color: "white", fontSize: "1.6vw", fontWeight: 500, fontFamily: "Poppins" }}>{isOrderFlow ? "Generated Order!" : "Generated Quote!"}</div>
    </Box>
  );
}

export default OrderPlaceScreen;
